// extracted by mini-css-extract-plugin
export default {"wrap":"ConsentGate_wrap__d2FX7","body":"ConsentGate_body__s9O9X","list":"ConsentGate_list__v9yax","error":"ConsentGate_error__Dj-aJ","actions":"ConsentGate_actions__mODBm"};